import { useEffect } from "react";

import CenteredLoader from "../components/CenteredLoader";
import AuthProvider from "../services/auth/AuthProvider/Index";

const LogoutCallback = () => {
  useEffect(() => {
    (async () => {
      await AuthProvider.logout();
    })();
  });

  return <CenteredLoader />;
};

export default LogoutCallback;
